import React, { useState, useEffect } from 'react';

export const ArtworkUpload = (props) => {
    const { uploadArtworkAction, initialArtist, initialTitle, initialAlbum } = props;
    const [image, setImage] = useState(null);
    const [filename, setFilename] = useState('');
    const [artist, setArtist] = useState(initialArtist);
    const [album, setAlbum] = useState(initialAlbum || initialTitle);

    const readBase64Image = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.result) {
                    const stringData = reader.result;
                    resolve(stringData);
                } else {
                    reject();
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const handleNewImage = async (files) => {
        if (files) {
            const newImage = files.item(0);
            if (newImage) {
                setFilename(`${newImage.name}-${new Date().getTime()}`);
                // Create a base64 image
                const base64Data = await readBase64Image(newImage);
                setImage(base64Data);
            }
        }
    };

    return (
        <React.Fragment>
            <div className="row">
                <div className="col">
                    <input
                        accept="image/*"
                        className=""
                        id="base64image-button-file"
                        type="file"
                        onChange={(e) => handleNewImage(e.target.files)}
                    />
                    {image ? <img height="100" src={image} alt="New Artwork" /> : null}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="form-group">
                        <label for="artistInput">Artist</label>
                        <input
                            type="text"
                            className="form-control mb-2 mr-sm-2"
                            placeholder="Artist"
                            id="artistInput"
                            name="Replacement Artist"
                            value={artist}
                            onChange={(event) =>
                                setArtist(event.target.value ? event.target.value : '')
                            }
                        />
                    </div>
                    <div className="form-group">
                        <label for="albumInput">Album</label>
                        <input
                            type="text"
                            className="form-control mb-2 mr-sm-2"
                            placeholder="Album"
                            id="albumInput"
                            name="Replacement Album"
                            value={album}
                            onChange={(event) =>
                                setAlbum(event.target.value ? event.target.value : '')
                            }
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <button
                        type="button"
                        onClick={() =>
                            uploadArtworkAction(
                                'custom:upload',
                                filename,
                                artist,
                                album,
                                '',
                                100,
                                100,
                                'image/jpeg',
                                image,
                            )
                        }
                        className="btn btn-primary mb-2 mr-sm-2"
                    >
                        Upload
                    </button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ArtworkUpload;
